"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var lodash_1 = __importDefault(require("lodash"));

var react_emotion_1 = require("react-emotion");

var object_values_1 = __importDefault(require("object.values"));

var constants_1 = require("./constants");

var util_1 = require("./util");

exports.round = util_1.round;

var color_1 = __importStar(require("./color"));

exports.Color = color_1.default;
exports.getPositions = color_1.getPositions;

var core_1 = __importDefault(require("./classes/core"));

exports.core = core_1.default;

var active_1 = __importDefault(require("./classes/active"));

exports.active = active_1.default;

var inline_1 = __importDefault(require("./classes/inline"));

exports.inline = inline_1.default;
var CtyledContext = react_1.createContext({
  theme: {},
  pstyle: {}
});
exports.CtyledContext = CtyledContext;
CtyledContext.displayName = 'CtyledContext';

var ThemeProvider = function ThemeProvider(_a) {
  var theme = _a.theme,
      props = __rest(_a, ["theme"]);

  return react_1.default.createElement(CtyledContext.Provider, __assign({
    value: {
      theme: theme,
      pstyle: {}
    }
  }, props));
};

exports.ThemeProvider = ThemeProvider;
var emptyObj = {},
    emptyArr = [],
    emptySinterp = [[], []];

var constructor = function constructor(Element, classDef, themeProps, inlineStyle, sheetStyle, defaultAttrs) {
  if (themeProps === void 0) {
    themeProps = emptyObj;
  }

  inlineStyle = inlineStyle || emptySinterp;
  sheetStyle = sheetStyle || emptySinterp;
  var attrsProps = defaultAttrs ? Object.keys(defaultAttrs || {}) : emptyArr;
  var CtyledComponent = react_1.memo(function (props) {
    var context = react_1.useContext(CtyledContext),
        theme = context.theme,
        pstyle = context.pstyle,
        style = props.style,
        _a = props.styles,
        styles = _a === void 0 ? emptyObj : _a,
        inRef = props.inRef,
        className = props.className,
        childProps = __rest(props, ["style", "styles", "inRef", "className"]),
        attrProps = react_1.useMemo(function () {
      return lodash_1.default.pick.apply(lodash_1.default, [props].concat(attrsProps));
    }, attrsProps.map(function (name) {
      return props[name];
    }));

    var getValue = react_1.useCallback(function (propName) {
      var propConfig = classDef.props[propName];
      var defaultFromConfig = propConfig.default;

      if (propConfig.extends) {
        var superValue = getValue(propConfig.extends);
        defaultFromConfig = lodash_1.default.isFunction(defaultFromConfig) ? defaultFromConfig(superValue) : superValue;
      }

      var themeValue = propConfig.inherit ? theme[propName] || defaultFromConfig : defaultFromConfig,
          compValue = styles[propName] || themeProps[propName];
      var finalValue;
      if (compValue === undefined) finalValue = themeValue;else if (compValue === 'inherit') finalValue = theme[propName] || defaultFromConfig;else if (lodash_1.default.isFunction(compValue)) finalValue = compValue(themeValue, attrProps);else finalValue = compValue;
      return propConfig.map ? propConfig.map(finalValue) : finalValue;
    }, [theme, styles, attrProps]);

    var _b = react_1.useMemo(function () {
      var computedProps = lodash_1.default.mapValues(classDef.props, function (propConfig, propName) {
        return getValue(propName);
      });
      return {
        computedThemeProps: computedProps,
        lastChildTheme: __assign({}, theme, computedProps)
      };
    }, [styles, theme, attrProps]),
        computedThemeProps = _b.computedThemeProps,
        lastChildTheme = _b.lastChildTheme;
    /* refProps computation */


    var refProps = {};

    if (inRef) {
      if (typeof Element === 'string') refProps.ref = inRef;else refProps.inRef = inRef;
    }
    /* stylesheet computation */


    var stylesClassName = react_1.useMemo(function () {
      var _a = util_1.joinTemplates(classDef.styles, sheetStyle),
          sheetCss = _a[0],
          sheetInterpolations = _a[1],
          sheetInterpValues = sheetInterpolations.map(function (interp) {
        if (typeof interp === 'function') return interp(computedThemeProps, attrProps);else return interp;
      }),
          sheetString = util_1.interpolateTemplate([sheetCss, sheetInterpValues]);

      return react_emotion_1.css([sheetString, []]);
    }, [computedThemeProps, attrProps]);
    /* inline style computation */

    var inline = react_1.useMemo(function () {
      var classInlineStyles = lodash_1.default.mapValues(classDef.inline, function (value) {
        if (lodash_1.default.isFunction(value)) return value(computedThemeProps);else return value;
      }),
          inlineCss = inlineStyle[0],
          interpolations = inlineStyle[1],
          interpValues = interpolations.map(function (interp) {
        if (lodash_1.default.isFunction(interp)) return interp(computedThemeProps, attrProps);else return interp;
      }),
          extendedInlineStyles = util_1.cssToInline(util_1.interpolateTemplate([inlineCss, interpValues]));
      return lodash_1.default.pickBy(__assign({}, classInlineStyles, extendedInlineStyles, style || {}), function (val, prop) {
        return !constants_1.inheritedProps.includes(prop) || pstyle[prop] !== val;
      });
    }, [computedThemeProps, attrProps, style, pstyle]);
    var childContextValue = react_1.useMemo(function () {
      return {
        theme: lastChildTheme,
        pstyle: __assign({}, pstyle, lodash_1.default.pick(inline, constants_1.inheritedProps))
      };
    }, [lastChildTheme, inline, pstyle]);
    var passThoughProps = react_1.useMemo(function () {
      return lodash_1.default.omit.apply(lodash_1.default, [childProps].concat(attrsProps));
    }, object_values_1.default(childProps).slice());
    var child = react_1.useMemo(function () {
      return react_1.default.createElement(Element, __assign({
        className: stylesClassName + ' ' + (className || ''),
        style: inline
      }, passThoughProps, refProps));
    }, [passThoughProps, stylesClassName, className, inline, refProps]);
    return lodash_1.default.isEqual(childContextValue, context) ? child : react_1.default.createElement(CtyledContext.Provider, {
      value: childContextValue
    }, child);
  });
  return Object.assign(CtyledComponent, {
    styles: function styles(newThemeProps) {
      return constructor(Element, classDef, Object.assign({}, themeProps, newThemeProps), inlineStyle, sheetStyle, defaultAttrs);
    },
    extend: function extend(strings) {
      var interps = [];

      for (var _i = 1; _i < arguments.length; _i++) {
        interps[_i - 1] = arguments[_i];
      }

      return constructor(Element, classDef, themeProps, util_1.joinTemplates(inlineStyle, [strings.slice(), interps]), sheetStyle, defaultAttrs);
    },
    extendSheet: function extendSheet(strings) {
      var interps = [];

      for (var _i = 1; _i < arguments.length; _i++) {
        interps[_i - 1] = arguments[_i];
      }

      return constructor(Element, classDef, themeProps, inlineStyle, util_1.joinTemplates([strings.slice(), interps], sheetStyle), defaultAttrs);
    },
    class: function _class(newClass) {
      return constructor(Element, util_1.mergeClasses(classDef, newClass), themeProps, inlineStyle, sheetStyle, defaultAttrs);
    },
    attrs: function attrs(newAttrs) {
      return constructor(Element, classDef, themeProps, inlineStyle, sheetStyle, Object.assign({}, defaultAttrs, newAttrs));
    },
    displayName: "Ctyled(" + (Element.name || Element) + ")"
  });
};

var coreConstructor = function coreConstructor(el) {
  return constructor(el, core_1.default);
};

constants_1.domels.forEach(function (el) {
  coreConstructor[el] = coreConstructor(el);
  coreConstructor[el].displayName = el;
});
exports.default = coreConstructor;